export const fwsed = {
  routes: [
    {
      path: "/fwsed/firm",
      component: () => import("../organization-firm-view"),
    },
    {
      path: "/fwsed/firm-management",
      component: () => import("../firm-detail-view"),
    },
  ],
};
